import type {GridPoint, MapRegistration} from "@/dungeons/model/DungeonGeometry.ts";
import {gridToImage} from "@/dungeons/geometry/Coordinates.ts";

type CanvasTransform = {x: number; y: number; scaleX: number; scaleY: number};

export function annotationScreenPosition(position: GridPoint, registration: MapRegistration,
    transform: CanvasTransform): GridPoint {
    const image = gridToImage(position, registration);
    return {x: transform.x + image.x * transform.scaleX, y: transform.y + image.y * transform.scaleY};
}
